import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';


@Component({
  selector: 'app-emitir-guiaremision-venta-modal',
  templateUrl: './emitir-guiaremision-venta-modal.component.html',
  styleUrls: ['./emitir-guiaremision-venta-modal.component.css']
})
export class EmitirGuiaremisionVentaModalComponent implements OnInit {
  @Input() venta_id: String;
  @Output() cerrarModal = new EventEmitter();
  constructor(
    public bsModalRef: BsModalRef,
  ) { }
    
  ngOnInit() {
  }

  onCerrarModal(event){
    if(event.close){
      this.bsModalRef.hide();
    }
    if(event.isSaved){
      this.cerrarModal.emit({isSaved:true});
    }
  }

}




// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/emitir-guiaremision-venta-modal/emitir-guiaremision-venta-modal.component.ts